global.conmed = global.conmed || {};

conmed.responsive_product_hero_img = function ($) {
    'use strict';
    var that = {
        selectors: {
            img: '.js-responsive-product-hero-img',
        }
    };

    that.init = function () {

        let images = $(that.selectors.img);
        
        images.each(that.setImgSize);

        $(window).on("resize", function () {

            if (that.delay) {
                clearTimeout(that.delay);
            }

            that.delay = setTimeout(function () {

                images.each(that.setImgSize);

            }, 500);
        });
    };

    that.getViewport = function () {

        let lg = 992;
        let md = 768;

        if (window.innerWidth >= lg) {
            return "lg";
        } else if (window.innerWidth >= md) {
            return "md";
        } else {
            return "sm";
        }
    };

    that.setImgSize = function () {

        let elm = $('.product-hero-image');

        let viewport = that.getViewport();

        let sm = elm.data("hero-img-sm");
        let md = elm.data("hero-img-md");
        let lg = elm.data("hero-img-lg");

        let result;

        if (viewport == "sm") {
            result = sm;
        }
        if (!result || viewport == "md") {
            result = md;
        }
        if (!result || viewport == "lg") {
            result = lg;
        }
        //$('.product-hero').addClass("img-" + viewport);

        $(elm).attr("src", result);
    };

    return that;
}(jQuery);